import { request } from '../utils/request';

export const loginByEmail = async (email, password) => {
	const data = new FormData();
	data.append('username', email);
	data.append('password', password);

	const response = await request({
		method: 'POST',
		url: '/login',
		data,
		isFormData: true,
	});

	if (response.status === 'success') {
		response.user = {
			name: response.displayName,
			email: response.email,
			organization: response.organizationName,
		};
	}

	return response;
};

export const changePassword = async (password) => {
	const data = new FormData();
	data.append('password', password);

	const response = await request({
		method: 'POST',
		url: '/login/password/model',
		data,
		isFormData: true,
	});

	return response;
};

export const forgotPassword = async (email) => {
	const data = new FormData();
	data.append('email', email);

	const response = await request({
		method: 'POST',
		url: '/login/recover',
		data,
		isFormData: true,
	});

	return response.valid;
};

export const verifyToken = async (token) => {
	const response = await request({
		method: 'GET',
		url: '/currentuser',
		token,
	});

	// TODO: Review this handling.
	if (response.loggedIn === true) {
		response.user = {
			name: response.loginDisplayName,
			email: response.email,
			organization: response.organizatonDisplayName,
		};
	}

	return response;
};
